module.exports = __webpack_public_path__ + "src/assets/img/bg_vas_pareja.37eaaeda.svg";